"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_apps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_518466eb-656f-4061-93a4-3294ff5d2435",
    "data-name": "518466eb-656f-4061-93a4-3294ff5d2435",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "bff60dc7-d938-4e21-8f6f-fe3efe21f526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be3a9362-89c3-4d1c-944e-8225ed7fb92c",
    d: "M82.39,150H45.66a6.59,6.59,0,0,1-5.86-3,6.4,6.4,0,0,1,.14-6.53l18.41-34.81a6.14,6.14,0,0,1,11.15,0l18.61,34.8a6.4,6.4,0,0,1,.15,6.53A6.6,6.6,0,0,1,82.39,150Z",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_397b2cae-0b43-4c5d-9920-9a777fa719b8",
    "data-name": "397b2cae-0b43-4c5d-9920-9a777fa719b8",
    d: "M64,85.92A21.88,21.88,0,1,1,85.92,64,21.89,21.89,0,0,1,64,85.92Z",
    transform: "translate(0 0)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.99 102.08 151.9 121.21 142.34 149.9 113.65 149.9 104.08 121.21 127.99 102.08",
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.12,
    y: 42,
    width: 43.93,
    height: 43.93,
    rx: 9.76,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 140,
    height: 140,
    rx: 12,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })));
}

var _default = ic_apps;
exports.default = _default;